import { logEvent, setUserId } from "firebase/analytics";
import {analytics, EventName, EventParams} from "./Firebase";


export const logFirebaseEvent = (eventName: EventName, eventParams : EventParams) => {
    logEvent(analytics, eventName.toString(), eventParams);
}
export const setFirebaseUserId = (userId : string) => {
    setUserId(analytics, userId)
}